import PubSub from "underpub-js";
import Equalizer from "../../../../scripts/classes/Equalizer";
import Slick from "slick-carousel";

var QuoteTallSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-QuoteTallSlider',
	};

	$.extend(true, this.options, options);

};

QuoteTallSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$quoteSlider = this.options.$el.find(`.${self.options.baseClass}__quoteSlider`);

	// initialize card slider
	this.$quoteSlider.slick({
		arrows: false,
		fade: true,
		speed: 400,
		slidesToShow: 1,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 8000,
	});

	// equalize slide heights
	this.slideEq = new Equalizer( self.options.$el.find(`.${self.options.baseClass}__slideContentWrapper`) );

	this.slideEq.equalizeHeights();

	PubSub.subscribe("resized", function(){
		self.slideEq.equalizeHeights();
	});


	// dots nav
	this.options.$el.find(`.${self.options.baseClass}__navDot`).on('click', function() {

		self.$quoteSlider.slick('slickGoTo', $(this).data('slideNumber') - 1);

	});

	this.$quoteSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	
		var activeSlideNumber = nextSlide + 1;

		self.options.$el.find(`.${self.options.baseClass}__navDot`).removeClass(`${self.options.baseClass}__navDot--active`);

		self.options.$el.find(`.${self.options.baseClass}__navDot` + '[data-slide-number="' + activeSlideNumber + '"]').addClass(`${self.options.baseClass}__navDot--active`);

	});

};

export default QuoteTallSlider;
